import React, { FC } from 'react';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import { AmountsInput } from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/AmountsInput';
import { useDerivedLiquidityByGammaInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedGammaMintInfo';
import { CreatePositionWithKpNft } from '@app/screens/liquidity/AddLiquidityV3/components/gamma/CreatePositionWithKpNft';
import { StrategySelector } from '@app/screens/liquidity/AddLiquidityV3/components/gamma/StrategySelector';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const AddLiquidityByGamma: FC<Props> = ({ mintInfo }) => {
  const { poolAddress } = mintInfo;

  const mintInfoWithProvider = useDerivedLiquidityByGammaInfo(poolAddress);

  return (
    <>
      <StrategySelector mintInfo={mintInfoWithProvider} />
      <AmountsInput mintInfo={mintInfoWithProvider} />
      <CreatePositionWithKpNft mintInfo={mintInfoWithProvider} />
    </>
  );
};
